import { useMemo } from 'react'
import icons from '@/assets/icons'
import GameInfo from './components/GameInfo'
import SJAvatar from '@/components/SJAvatar'
import { useNavigate } from 'react-router-dom'
import user from '@/stores/user'
import { observer } from 'mobx-react'
import SJSpace from '@/components/SJSpace'
import useValidateCmcc from '@/hooks/useValidateCmcc'
import './index.less'

const ChessIndex = () => {
  document.title = '对弈记录'
  useValidateCmcc()
  const navigate = useNavigate()

  const curPlayer = useMemo(
    () => user.curPlayer || user.userPlayer,
    [user.curPlayer, user.userPlayer],
  )

  const switchPlayer = () => {
    navigate('/player/switch', { state: { playerId: curPlayer.playerId } })
  }

  return (
    <div className="page chess-index">
      <SJAvatar className="page-avatar" src={curPlayer.avatarUrl} name={curPlayer.name}></SJAvatar>
      <div className="main">
        <div className="switch hoverClass" onClick={switchPlayer}>
          <img src={icons.IconSwitch} alt="" />
          <span className="fs12">切换棋手</span>
        </div>
        <div className="content">
          {curPlayer.playerId && <GameInfo playerId={curPlayer.playerId}></GameInfo>}
        </div>
      </div>
      <SJSpace height={20} />
    </div>
  )
}

export default observer(ChessIndex)
